// @react-functional

import React from 'react';
import { useModal } from '../../../components/modal/useModal';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { CommentaryLegislationSourcesModal } from './CommentaryLegislationSourcesModal';
import { CommentarySourceType } from '../../commentary.types';

type Props = {
  source: string;
  commentaryId: string;
};

export const useCommentaryLegislationSourcesModal = ({
  source,
  commentaryId,
}: Props) => {
  const { openModal } = useModal(
    (modalProps) => (
      <CommentaryLegislationSourcesModal
        source={source}
        {...modalProps}
        commentaryId={commentaryId}
      />
    ),
    [commentaryId, source],
  );
  return () => {
    doctrineAnalytics('Search ModalCommentarySourcesOpened', {
      source,
      commentaryId,
      type: CommentarySourceType.LEGISLATION,
    });
    openModal();
  };
};
